import * as React from "react";
import useProductName from "brand-customization/useProductName";
import { Col, Row } from "components/bootstrap";
import { DocumentTitle, PageHeader } from "components/common";
import DocsHelper from "util/DocsHelper";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import ReportsList from "./ReportsList";
import ReportsSubNav from "../common/ReportsSubNav";
const ReportsPage = () => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Reports" }, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: "Reports",
      actions: /* @__PURE__ */ React.createElement(ReportsSubNav, null),
      documentationLink: {
        title: "Reporting documentation",
        path: DocsHelper.PAGES.REPORTING
      }
    },
    /* @__PURE__ */ React.createElement("span", null, "Reports let you relay information from ", productName, " in a presentable form. They are based on dashboard widgets, highly customizable and can be scheduled for automatic delivery.")
  ), /* @__PURE__ */ React.createElement(LicenseCheck, { licenseSubject: LICENSE_SUBJECTS.report, bsStyle: "danger", displayWarningContainer: true, hideChildren: true }, /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(ReportsList, null)))));
};
export default ReportsPage;
